import React, { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from '@decisiv/ui-components/lib/components';
import iconix from '@decisiv/iconix/lib/components';
import { t } from '@lingui/macro';

import NavMenu from '../NavMenu';
import { useIntegrationsActions } from '../../contexts/IntegrationsActionsContext';
import { MenuTriggerWrapper } from './style';

export default function IntegrationsMenu() {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [menu, setMenu] = useState();
  const popRef = useRef();
  const setMenuRef = useCallback(setMenu, []);

  const { available, onImport, onStartExport } = useIntegrationsActions();

  const items = [
    {
      id: 'create-integration',
      text: t`Create Integration`,
      icon: iconix.PlusCircle,
      onSelect: () => navigate('/integrations/create'),
    },
    ...(available
      ? [
          {
            id: 'import-integrations',
            text: t`Import Integration(s)`,
            icon: iconix.Upload,
            onSelect: onImport,
          },
          {
            id: 'export-integrations',
            text: t`Export Integration(s)`,
            icon: iconix.Download,
            onSelect: onStartExport,
          },
        ]
      : []),
  ];

  const localSelectItem = () => {
    popRef.current.hide();
  };

  return (
    <MenuTriggerWrapper>
      <NavMenu
        popoverRef={popRef}
        contentRole="menu"
        emblem={() => <iconix.Grid size="small" />}
        primaryText={t`Integrations`}
      >
        <Menu ref={setMenuRef} items={items} onSelectItem={localSelectItem} />
      </NavMenu>
    </MenuTriggerWrapper>
  );
}
